import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export function useStock() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios); authAxiosRef.current = authAxios;
  const [items, setItems] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [movements, setMovements] = useState([]);
  const [costReport, setCostReport] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    try {
      const [itemsRes, alertsRes, recipesRes, movesRes, prodsRes] = await Promise.all([
        authAxiosRef.current.get("/stock"),
        authAxiosRef.current.get("/stock/alerts"),
        authAxiosRef.current.get("/stock/recipes"),
        authAxiosRef.current.get("/stock/movements?limit=30"),
        authAxiosRef.current.get("/menu/products"),
      ]);
      setItems(itemsRes.data);
      setAlerts(alertsRes.data);
      setRecipes(recipesRes.data);
      setMovements(movesRes.data);
      const prods = Array.isArray(prodsRes.data) ? prodsRes.data : prodsRes.data?.products || [];
      setProducts(prods);
    } catch {
      toast.error("Error cargando datos");
    }
    setLoading(false);
  }, []);

  const fetchCosts = useCallback(async () => {
    try {
      const res = await authAxiosRef.current.get("/stock/costs");
      setCostReport(res.data);
    } catch {
      toast.error("Error cargando costes");
    }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const deleteIngredient = async (id) => {
    if (!window.confirm("Eliminar este ingrediente?")) return;
    try {
      await authAxios.delete(`/stock/${id}`);
      toast.success("Eliminado");
      fetchAll();
    } catch {
      toast.error("Error");
    }
  };

  const deleteRecipe = async (productId) => {
    if (!window.confirm("Eliminar esta ficha tecnica?")) return;
    try {
      await authAxios.delete(`/stock/recipes/${productId}`);
      toast.success("Ficha eliminada");
      fetchAll();
    } catch {
      toast.error("Error");
    }
  };

  return {
    authAxios,
    items,
    alerts,
    recipes,
    movements,
    costReport,
    products,
    loading,
    fetchAll,
    fetchCosts,
    deleteIngredient,
    deleteRecipe,
  };
}
